/*
 * @Desc: 微信分享
 * @Author: Eleven
 * @Date: 2018-11-24 02:07:35
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2018-11-26 18:33:19
 */

import { isTest } from "./index";
import { http } from "../service";

class WxShare {
  constructor(shareParams, shareConfig) {
    // 微信SDK权限验证接口,需要的参数.
    this.shareParams = {
      ...{
        url: `//m.ximalaya.com/x-thirdparty-web/weixinJssdk/config`, // 生产环境地址
        urlTest: `//m.test.ximalaya.com/x-thirdparty-web/weixinJssdk/config`, // 测试环境地址
        thirdpartyId: null, // 接入时分配的thirdpartyId
        signatureUrl: window.location.href // 当前页面url,需要encode
      },
      ...shareParams
    };

    // 自定义分享参数
    this.shareConfig = {
      ...{
        title: "", // 分享卡片的title
        desc: "", // 分享卡片的描述
        link: window.location.href, //
        imgUrl: null // 分享卡片的头图
      },
      ...shareConfig
    };
  }

  init() {
    const wx = window.wx;

    // 如果未引入微信SDK,中止.
    if (!wx) return;

    /**
     * 调用统一接口,生成签名,获取调用微信接口需要的参数.
     */
    this.getConfig().then(res => {
      if (!res || !res.appId || !res.signature) return;

      // 需从接口获取以下签名参数
      const { appId, nonceStr, signature, timestamp } = res;
      const { shareConfig } = this;

      /**
       * config接口,注入权限验证配置.
       */
      wx.config({
        debug: false, // (生产环境不开启)开启调试模式,调用的所有api的返回值会在客户端alert出来
        appId, // 必填，公众号的唯一标识
        timestamp, // 必填，生成签名的时间戳
        nonceStr, // 必填，生成签名的随机串
        signature, // 必填，签名
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "chooseImage",
          "uploadImage",
          "downloadImage"
        ] // 必填，需要使用的JS接口列表
      });

      /**
       * ready接口,处理成功验证.
       */
      wx.ready(function() {
        wx.onMenuShareAppMessage(shareConfig);
        wx.onMenuShareTimeline(shareConfig);
        wx.onMenuShareQQ(shareConfig);
        wx.onMenuShareWeibo(shareConfig);
      });

      /**
       * error接口,处理失败验证.
       */
      wx.error(function(res) {
        // To-Do
        console.log(res, "wx.error...");
      });
    });
  }

  /**
   * 生成签名,获取后续调用微信接口需要的参数.
   * (创建$axios的时候,不要加 withCredentials: true !! 因这个接口的接口端已做了处理.)
   */
  getConfig() {
    //  生产环境/非生产环境使用不同接口
    const url = !isTest ? this.shareParams.url : this.shareParams.urlTest;
    const { thirdpartyId, signatureUrl } = this.shareParams;

    return http.get(url, {
      thirdpartyId,
      signatureUrl
    });
  }
}

export default WxShare;



// WEBPACK FOOTER //
// ./src/utils/wxShare.js